export default {
  setLogs(state, value) {
    state.logs = value
  },
  setLogFilters(state, value) {
    state.logFilters = value
  },
}
